import * as React from "react";
import { LoadingDotWrapper, LoadingDot } from "./styles";
export function Loading({ style = {} }) {
    return (React.createElement(LoadingDotWrapper, { style: style },
        React.createElement(LoadingDot, null,
            React.createElement("div", { className: "loaderdot" }),
            React.createElement("div", { className: "loaderdot" }),
            React.createElement("div", { className: "loaderdot" }),
            React.createElement("div", { className: "loaderdot" }),
            React.createElement("div", { className: "loaderText" }))));
}
export default Loading;
